export class PCSStringUtils {
    public static generateUniqueCopyName(baseString: string | undefined, existingStrings: string[]): string {
        const copySuffix: string = "_Copy_";

        if (!baseString)
            return "";
        if (existingStrings.includes(baseString)) {
            if (! baseString.includes(copySuffix)) {
                let suffixes = existingStrings
                    .filter(str => str.startsWith(baseString + copySuffix)) // Filter matching prefix
                    .map(str => {
                        let match = str.match(/_(\d+)$/);
                        return match ? parseInt(match[1], 10) : 0;
                    })
                    .filter(n => n !== null); // Remove null values

                let suffix = suffixes.length > 0 ? Math.max(...suffixes) : 0;
                return baseString + copySuffix + "_" + (suffix+1);
            }
        }
        return baseString + copySuffix + "_1";
    }
}